import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Router from './Router';
import reportWebVitals from './reportWebVitals';
import firebase from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyACA3EbIucWUmnlq4HYXrYKi3zFZueG06Y",
  authDomain: "mcq-bank-8c68f.firebaseapp.com",
  projectId: "mcq-bank-8c68f",
  storageBucket: "mcq-bank-8c68f.appspot.com",
  messagingSenderId: "356236990607",
  appId: "1:356236990607:web:958f38e459bfac534a38fa",
  measurementId: "G-X9R11KLFCL"
};

!firebase.apps.length && firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
